import { get } from 'http';
import { api } from './api';
import { PricingPlanSubscription } from 'types';

const RESOURCE_PATH = `/`;

type SelectPricingPlanResponse = {
    status: string;
    subscription: PricingPlanSubscription;
};

type ChangePricingPlanResponse = {
    status: string;
    subscription: PricingPlanSubscription;
    new_subscription: PricingPlanSubscription;
    immediately: boolean;
};

type CancelSubscriptionResponse = {
    status: string;
    subscription: PricingPlanSubscription;
    immediately: boolean;
};


export const paymentsApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    getPricingPlans: builder.query<any, void>({
        query: () => `${RESOURCE_PATH}payments/pricing-plans/`,
        providesTags: [{ type: 'PricingPlans', id: 'PRICING_PLANS' }],
    }),
    getPricingPlan: builder.query<any, { planId: string }>({
        query: ({ planId }) => `${RESOURCE_PATH}payments/pricing-plans/${planId}/`,
        providesTags: (result, error, { planId }) => [{ type: 'PricingPlans', id: planId }],
    }),
    selectPricingPlan: builder.mutation<SelectPricingPlanResponse, { planId: string }>({
        query: ({ planId }) => ({
            url: `${RESOURCE_PATH}payments/pricing-plan/${planId}/subscribe/`,
            method: 'POST',
        }),
        invalidatesTags: [{ type: 'PricingPlans', id: 'PRICING_PLANS' }],
    }),
    cancelSubscription: builder.mutation<CancelSubscriptionResponse, { immediately?: boolean }>({
        query: ({ immediately }) => ({
            url: `${RESOURCE_PATH}payments/pricing-plans/cancel_current_subscription/`,
            method: 'POST',
            body: { immediately: immediately || false },
        }),
        invalidatesTags: [{ type: 'PricingPlans', id: 'PRICING_PLANS' }],
    }),
    changePricingPlan: builder.mutation<ChangePricingPlanResponse, { planId: string, immediately?: boolean }>({
        query: ({ planId, immediately }) => ({
            url: `${RESOURCE_PATH}payments/pricing-plans/${planId}/update_subscription/`,
            method: 'POST',
            body: { immediately: immediately || false },
        }),
        invalidatesTags: [{ type: 'PricingPlans', id: 'PRICING_PLANS' }],
    }),
  }),
});

export const { useGetPricingPlansQuery, useGetPricingPlanQuery, useSelectPricingPlanMutation, useCancelSubscriptionMutation, useChangePricingPlanMutation } = paymentsApiSlice;